// extracted by mini-css-extract-plugin
export default {"timeSlot":"TimeSlot_timeSlot__chtER","dropPreview":"TimeSlot_dropPreview__jVsQO","dropPreviewLabel":"TimeSlot_dropPreviewLabel__KPcvA"};